import { useEffect, useState } from "react";
import axios from "axios";
import { Mail, Clock, BarChart3 } from "lucide-react";
import { API, authHeaders } from "./adminApi";

function StatCard({ icon: Icon, label, value, sub, accent = "#1B5E20" }) {
  return (
    <div className="bg-white rounded-3xl p-6 border border-[#E5EBE5] hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between mb-3">
        <div
          className="w-11 h-11 rounded-2xl flex items-center justify-center"
          style={{ backgroundColor: `${accent}15` }}
        >
          <Icon className="w-5 h-5" style={{ color: accent }} />
        </div>
      </div>
      <div className="font-['Outfit'] text-3xl font-semibold text-[#1A2E1C]">
        {value}
      </div>
      <div className="text-sm text-[#5C705E] mt-1">{label}</div>
      {sub && <div className="text-xs text-[#5C705E]/70 mt-2">{sub}</div>}
    </div>
  );
}

export default function DashboardOverview({ token, onUnauthorized }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/admin/stats`, { headers: authHeaders(token) })
      .then((r) => setStats(r.data))
      .catch((err) => {
        if (err?.response?.status === 401) onUnauthorized?.();
      })
      .finally(() => setLoading(false));
  }, [token, onUnauthorized]);

  if (loading) {
    return <div className="text-center py-20 text-[#5C705E]">Chargement…</div>;
  }
  if (!stats) {
    return <div className="text-center py-20 text-[#5C705E]">Aucune donnée disponible.</div>;
  }

  return (
    <div data-testid="admin-dashboard" className="space-y-8">
      <header>
        <h2 className="font-['Outfit'] text-3xl font-semibold text-[#1A2E1C]">
          Tableau de bord
        </h2>
        <p className="text-[#5C705E] mt-1">Vue d'ensemble de l'activité.</p>
      </header>

      <div className="grid sm:grid-cols-2 gap-5">
        <StatCard
          icon={Mail}
          label="Contacts ce mois"
          value={stats.contacts_month}
          sub={`${stats.contacts_total} au total`}
          accent="#1B5E20"
        />
        <StatCard
          icon={Clock}
          label="Contacts en attente"
          value={stats.contacts_pending}
          accent="#D32F2F"
        />
      </div>

      <div className="grid gap-5">
        <div className="bg-white rounded-3xl border border-[#E5EBE5] p-6">
          <div className="flex items-center gap-2 mb-5 text-[#1A2E1C] font-['Outfit'] font-semibold">
            <BarChart3 className="w-5 h-5 text-[#1B5E20]" />
            Services les plus demandés
          </div>
          {stats.top_services.length === 0 ? (
            <p className="text-sm text-[#5C705E]">Aucun service renseigné pour l'instant.</p>
          ) : (
            <ul className="space-y-3">
              {stats.top_services.map((s) => {
                const max = stats.top_services[0].count || 1;
                const pct = (s.count / max) * 100;
                return (
                  <li key={s.service}>
                    <div className="flex justify-between text-sm text-[#1A2E1C] mb-1">
                      <span>{s.service}</span>
                      <span className="font-semibold">{s.count}</span>
                    </div>
                    <div className="h-2 rounded-full bg-[#E5EBE5] overflow-hidden">
                      <div
                        className="h-full bg-[#1B5E20] rounded-full"
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
